import { createContext, useEffect, useState, useContext } from 'react';
import { supabase } from '../supabaseClient';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        supabase.auth.getSession().then(async ({ data: { session } }) => {
            if (session?.user) {
                const userEmail = session.user.email;

                const { data: admins } = await supabase
                    .from('admin_users')
                    .select('email')
                    .eq('email', userEmail);

                setUser(session.user);
                setIsAdmin(admins.length > 0);
            }
            setLoading(false);
        });

        const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
            if (session?.user) {
                const userEmail = session.user.email;

                supabase
                    .from('admin_users')
                    .select('email')
                    .eq('email', userEmail)
                    .then(({ data }) => {
                        setUser(session.user);
                        setIsAdmin(data.length > 0);
                    });
            } else {
                setUser(null);
                setIsAdmin(false);
            }
        });

        return () => {
            listener.subscription.unsubscribe();
        };
    }, []);

    return (
        <AuthContext.Provider value={{ user, isAdmin, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
